import { Link } from "react-router";
import { buttonClass } from "@/design/buttons";

/**
 * A URL this app does not serve.
 *
 * **New surface, and the client-rendered app is the reason.** The Next host
 * answered an unknown path with a real 404 from the server; a static app is
 * served the same `index.html` for every path, so the router has to say it
 * instead. The status code is genuinely 200, which is the honest cost of the
 * split and matters to nobody but a crawler.
 *
 * The way out is the landing page rather than `roleHome`: a mistyped URL says
 * nothing about who is reading it, and sending a member to their dashboard from
 * here would be guessing.
 */
export function NotFoundScreen() {
  return (
    <div className="mx-auto flex w-full max-w-2xl grow flex-col items-start px-4 py-20 sm:px-6">
      <p className="font-mono text-xs uppercase tracking-wider text-muted">
        404
      </p>
      <h1 className="mt-2 font-display text-3xl font-bold text-ink">
        We could not find that page
      </h1>
      <p className="mt-3 text-body">
        The link may be out of date, or the address may have a typo in it.
      </p>
      <Link to="/" className={`${buttonClass("primary")} mt-8`}>
        Go to the home page
      </Link>
    </div>
  );
}
